<template>
  <div>
    <div>
      <base-cell
        v-for="(opt, index) in videoDevices"
        :key="opt.deviceId"
        @click="changeCamera(index)"
      >
        {{ opt.label.includes('Camera') ? opt.label : 'Camera ' + opt.label }}
      </base-cell>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectCameraModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: null,
      stream: null,
      deviceInfos: null,
      videoDevices: [],
      selectedVideoDevice: null,
      constraints: {
        audio: true,
        video: { width: '100%' },
      },
    };
  },
  mounted() {
    this.getStream().then(this.getDevices).then(this.gotDevices);
  },
  methods: {
    changeCamera(selectedIndex) {
      this.selected = selectedIndex;
      this.gotStream();
    },
    getDevices() {
      // AFAICT in Safari this only gets default devices until gUM is called :/
      return navigator.mediaDevices.enumerateDevices();
    },

    gotDevices(deviceInfos) {
      this.deviceInfos = deviceInfos; // make available to console
      deviceInfos.forEach((deviceInfo) => {
        if (deviceInfo.kind === 'videoinput') {
          this.videoDevices.push(deviceInfo);
        }
      });
    },
    async getStream() {
      if (this.stream) {
        this.stream.getTracks().forEach((track) => {
          track.stop();
        });
      }
      return navigator.mediaDevices.getUserMedia(this.constraints);
    },

    async gotStream() {
      if (this.videoDevices && this.videoDevices.length > 0) {
        this.selectedVideoDevice = this.videoDevices[this.selected];
        if (this.selectedVideoDevice.label === 'Front Camera') {
          this.constraints.video.facingMode = { exact: 'user' };
        } else if (this.selectedVideoDevice.label === 'Back Camera') {
          this.constraints.video.facingMode = { exact: 'environment' };
        } else {
          this.constraints.video = { width: '100%' };
        }
        this.constraints.video.deviceId = { exact: this.selectedVideoDevice.deviceId };
      }
      this.stream = await this.getStream();
      this.$emit('stream', this.stream);
    },

    handleError(error) {
      console.error('Error: ', error);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
